import { SVGProps } from 'react';

export const SvgCardPos = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={24}
    width={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.8832 2.38425C17.1588 2.65992 17.1588 3.10686 16.8832 3.38252L3.3847 16.881C3.10904 17.1566 2.6621 17.1566 2.38644 16.881C2.11077 16.6053 2.11077 16.1584 2.38644 15.8827L15.8849 2.38425C16.1605 2.10859 16.6075 2.10859 16.8832 2.38425Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.8412 17.238C13.1168 17.5137 13.1168 17.9606 12.8412 18.2363L11.4857 19.5918C11.21 19.8674 10.7631 19.8674 10.4874 19.5918C10.2118 19.3161 10.2118 18.8692 10.4874 18.5935L11.8429 17.238C12.1186 16.9623 12.5655 16.9623 12.8412 17.238Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2258 12.855C17.5015 13.1306 17.5015 13.5776 17.2258 13.8532L14.5261 16.5529C14.2505 16.8286 13.8035 16.8286 13.5279 16.5529C13.2522 16.2773 13.2522 15.8303 13.5279 15.5546L16.2276 12.855C16.5032 12.5793 16.9502 12.5793 17.2258 12.855Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.01 1.41179C12.4299 1.41545 11.7155 1.80824 10.5142 3.00956L3.01377 10.5099C1.80602 11.7177 1.41452 12.4314 1.41178 13.009C1.40906 13.5831 1.79003 14.286 2.97989 15.4759L8.52611 21.0221C9.71435 22.2103 10.4202 22.5896 10.9961 22.586C11.5763 22.5823 12.2907 22.1895 13.492 20.9882L20.9924 13.4878C22.1937 12.2865 22.5865 11.5721 22.5902 10.9919C22.5938 10.416 22.2145 9.71014 21.0263 8.52189L15.4801 2.97567C14.2918 1.78743 13.586 1.40816 13.01 1.41179ZM13.0011 5.44865e-05C14.2156 -0.00760773 15.2945 0.793533 16.4783 1.9774L22.0246 7.52362C23.2084 8.70749 24.0096 9.78637 24.0019 11.0008C23.9943 12.211 23.1841 13.2927 21.9907 14.4861L14.4903 21.9865C13.2969 23.1798 12.2152 23.9901 11.005 23.9977C9.79058 24.0054 8.71171 23.2042 7.52784 22.0203L1.98162 16.4741C0.799366 15.2919 -0.00571999 14.2157 3.06076e-05 13.0023C0.00576494 11.7923 0.817261 10.7099 2.01551 9.51168L9.5159 2.01129C10.7093 0.817897 11.7909 0.00768983 13.0011 5.44865e-05Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 23.2941C0 22.9043 0.316034 22.5882 0.705882 22.5882H23.2974C23.6873 22.5882 24.0033 22.9043 24.0033 23.2941C24.0033 23.684 23.6873 24 23.2974 24H0.705882C0.316034 24 0 23.684 0 23.2941Z"
    />
  </svg>
);
